module.exports = __webpack_public_path__ + "media/images/flip-bdbece2c19fbe613c60afdbb10aa25a346c7dd4206bc0c148ed8d68b00bec026.svg";